import { useDynamicData } from '@avensia/excite';
import { pathToSlug } from 'webapp/utils/string';
import { getRetailMediaSessionId, getUserId } from '../../tracking/utils';

export function useRetailMedia(
  placement: string,
  category?: string,
  searchTerm?: string,
  productId?: string,
  selectedFacets?: Excite.Esales.FacetApiModel[],
  enabled: boolean = false,
) {
  const categoryId = category
    ?.split('/')
    .filter(part => part !== '')
    .map(part => pathToSlug(part))
    .join('|');

  const [retailMediaContent] = useDynamicData<NordicNest.Api.RetailMediaApiModel>({
    context: {
      placement: placement,
      category: categoryId,
      searchTerm: searchTerm,
      productId: productId,
      selectedFacets: selectedFacets,
      visitorId: getRetailMediaSessionId(),
      customerId: getUserId(),
    },
    shouldResolveData: enabled,
  });

  return retailMediaContent;
}
